import { render, staticRenderFns } from "./PreviewImg.vue?vue&type=template&id=4cbd5aef&scoped=true"
import script from "./PreviewImg.vue?vue&type=script&lang=js"
export * from "./PreviewImg.vue?vue&type=script&lang=js"
import style0 from "./PreviewImg.vue?vue&type=style&index=0&id=4cbd5aef&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cbd5aef",
  null
  
)

export default component.exports